module.exports = __webpack_public_path__ + "img/bestEmployee.ee74d256.png";